import { useEffect, useState } from 'react'
import '../css/custom.error.css'
import BlobModalComponent from '../../blobs/BlobModalComponent'
import JSONPretty from 'react-json-pretty'
import { CUSTOM_JSON_THEME } from '../common.constants'
import ExclainSvg from './svg/ExclaimSvg'
import { Button } from 'react-bootstrap'
import ArrowRightSvg from './svg/ArrowRightSvg'
import XSvg from './svg/X-Svg'

export interface CustomErrorProps {
  visible?: boolean | undefined
  title?: string
  description?: any
  content?: any
  closeError?: any
}

export default function CustomError({ visible, title, description, content, closeError }: CustomErrorProps) {
  const [blobVisible, setBlobVisible] = useState(false)
  const [shouldRender, setShouldRender] = useState(visible)
  const [isVisible, setIsVisible] = useState(visible)

  // Control open/close animation state
  useEffect(() => {
    if (visible) {
      setShouldRender(true)
      setTimeout(() => setIsVisible(true), 10) // trigger open animation slightly after mount
    } else {
      setIsVisible(false)
      const timeout = setTimeout(() => setShouldRender(false), 300)
      return () => clearTimeout(timeout)
    }
  }, [visible])

  const handleClose = () => {
    setIsVisible(false)
    setTimeout(() => {
      setShouldRender(false)
      closeError?.()
    }, 300)
  }

  if (!shouldRender) return null

  let parsedContent = content
  let isJson = false
  try {
    parsedContent = JSON.parse(content)
    isJson = true
  } catch (error) {}

  const blobView = isJson
    ? <JSONPretty data={parsedContent} theme={CUSTOM_JSON_THEME} style={{ fontSize: '1.5em' }} />
    : content

  return (
    <div className={`custom-error-el ${isVisible ? 'opened' : 'closed'}`}>
      <BlobModalComponent
        raw={content}
        blobData={blobView}
        blobName={title}
        closeModal={() => setBlobVisible(false)}
        modalVisible={blobVisible}
      />
      <span>
        <span className='custom-error-title'><ExclainSvg height={30} /> {title?.toUpperCase()}</span>
        <span className='custom-error-description'><ArrowRightSvg height={30}/> {description}</span>
        {content && (
          <>
            &nbsp;&nbsp;
            <Button onClick={() => setBlobVisible(true)} variant='secondary'>
              <ExclainSvg height={15}/> VIEW
            </Button>
          </>
        )}
        {closeError && (
          <span
            onClick={handleClose}
            style={{
              float: 'right',
              color: 'white',
              border: 'solid white 1px',
              borderRadius: '5px',
              cursor: 'pointer',
            }}
          >
            <XSvg height={25}/>
          </span>
        )}
      </span>
    </div>
  )
}
